export const ProfilesConstant = {
  admin: 'admin_intelidente_light',
  dentist: 'professional_intelidente_light',
  receptionist: 'receptionist_intelidente_light',
};
